<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button
        size="small"
        class="filter-item"
        type="primary"
        @click="showallbatch"
        icon="el-icon-right"
      >
        一键充值
      </el-button>
      <el-button
        size="small"
        class="filter-item"
        type="primary"
        icon="el-icon-plus"
        @click="createuser"
      >
        创建用户
      </el-button>
      <el-input
        size="small"
        v-model="listQuery.username"
        placeholder="请输入用户名称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        size="small"
        v-model="listQuery.last_name"
        placeholder="请输入姓"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        size="small"
        v-model="listQuery.first_name"
        placeholder="请输入名"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        size="small"
        v-model="listQuery.user_id"
        placeholder="请输入用户ID"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        size="small"
        v-model="listQuery.uuid"
        placeholder="请输入用户UUID"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        size="small"
        v-model="listQuery.email"
        placeholder="请输入邮箱"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <!-- <el-input
        size="small"
        v-model="listQuery.phone"
        placeholder="请输入手机号"
        style="width: 200px"
        class="filter-item"
        clearable
      /> -->
      <el-select
        size="small"
        v-model="listQuery.vip_status"
        placeholder="会员状态"
        clearable
        style="width: 200px"
        class="filter-item"
      >
        <el-option label="VIP已激活" value="active" />
        <el-option label="VIP未激活" value="inactive" />
        <el-option label="VIP未激活-网红" value="inactive_affiliate" />
        <el-option label="非VIP" value="never_purchased" />
      </el-select>
      <el-select
        size="small"
        v-model="listQuery.is_normal"
        placeholder="状态"
        clearable
        style="width: 200px"
        class="filter-item"
      >
        <el-option label="正常" value="1" />
        <el-option label="已冻结" value="0" />
      </el-select>
      <el-button
        size="small"
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索
      </el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="用户 ID" width="80">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户名称" width="120">
        <template slot-scope="scope">
          {{ scope.row.username || '' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="UUID" width="120">
        <template slot-scope="scope">
          {{ scope.row.uuid }}
        </template>
      </el-table-column>
      <el-table-column label="名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.first_name || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="姓" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.last_name || '-' }}
        </template>
      </el-table-column>

      <!-- <el-table-column label="邀请码" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.invite_code || '-' }}
        </template>
      </el-table-column> -->
      <el-table-column label="vip点数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.vip_point || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="VIP状态" min-width="130">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.vip_status === 'active'" type="success"
            >VIP已激活
          </el-tag>
          <el-tag v-else-if="scope.row.vip_status === 'inactive'" type="warning"
            >VIP未激活
          </el-tag>
          <el-tag
            v-else-if="scope.row.vip_status === 'inactive_affiliate'"
            type="primary"
            >VIP未激活-网红
          </el-tag>
          <el-tag
            v-else-if="scope.row.vip_status === 'never_purchased'"
            type="danger"
            >非VIP
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="公司" min-width="140" align="center">
        <template slot-scope="scope">
          {{ scope.row.company ? scope.row.company : '-' }}
        </template>
      </el-table-column>

      <el-table-column align="center" label="联系方式" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.contact ? scope.row.contact : '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="地址" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.address || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="推荐人ID" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.team.parent?.uuid ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="绑定邮箱" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.email ? scope.row.email : '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="未处理奖励金" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.none_commission }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="待结算奖励金" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.pending_balance }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="已入账奖励金" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.available_balance }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="已提现奖励金" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.withdrawn_balance }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="可提现奖励金" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.can_withdraw }}
        </template>
      </el-table-column>

      <el-table-column align="center" label="RP" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.can_use_rp }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="GP" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.can_use_hp }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" min-width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_normal === 1" type="success">正常</el-tag>
          <el-tag v-else-if="scope.row.is_normal === 0" type="warning"
            >已冻结
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="edit(scope.row)">
            编辑会员信息
          </el-button>
          <el-button
            type="danger"
            size="mini"
            v-if="scope.row.is_normal"
            @click="forbid(scope.row)"
          >
            {{ '冻结' }}
          </el-button>
          <el-button
            type="success"
            size="mini"
            v-else
            @click="forbid(scope.row)"
          >
            {{ '解冻' }}
          </el-button>
          <div style="margin-top: 5px">
            <el-button
              type="primary"
              size="mini"
              @click="showrowbatch(scope.row)"
            >
              充值
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      :title="isall ? '一键充值全体用户' : '充值'"
      :visible.sync="batchModalVisible"
      :destroy-on-close="true"
      append-to-body
      width="512px"
    >
      <el-form
        ref="batchForm"
        label-position="top"
        :model="batchForm"
        :rules="batchRules"
        label-width="150px"
      >
        <el-form-item prop="recharge_type" label="充值类型">
          <el-radio v-model="batchForm.recharge_type" label="balance"
            >奖励金
          </el-radio>
          <el-radio v-model="batchForm.recharge_type" label="rp">RP</el-radio>
          <el-radio v-model="batchForm.recharge_type" label="hp">GP</el-radio>
        </el-form-item>
        <el-form-item prop="recharge_value" label="">
          <el-input
            v-model="batchForm.recharge_value"
            placeholder="请输入奖励金额"
          ></el-input>
        </el-form-item>
        <el-row type="flex" justify="end">
          <el-button @click="batchModalVisible = false">取消</el-button>
          <el-button type="primary" :loading="btnLoading" @click="batch"
            >确认
          </el-button>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      batchModalVisible: false,
      batchRules: {
        recharge_type: [
          { required: true, message: '请选择充值类型', trigger: 'blur' },
        ],
        recharge_value: [
          { required: true, message: '请输入奖励金额', trigger: 'blur' },
        ],
      },
      btnLoading: false,
      isall: false,
      batchForm: {
        user_ids: [0],
        recharge_type: '',
        recharge_value: '',
      },
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        last_name: '',
        first_name: '',
        user_id: '',
        username: '',
        email: '',
        phone: '',
        is_normal: '',
      },
    }
  },
  created() {
    this.getList()
  },
  watch: {
    batchModalVisible() {
      this.batchForm = {
        ...this.batchForm,
        reason: '',
      }
    },
  },
  methods: {
    showrowbatch(row) {
      this.isall = false
      this.batchModalVisible = true
      this.batchForm = {
        user_ids: [row.id],
        recharge_type: '',
        recharge_value: '',
      }
    },
    showallbatch() {
      this.isall = true
      this.batchModalVisible = true
      this.batchForm = {
        user_ids: [0],
        recharge_type: '',
        recharge_value: '',
      }
    },
    batch() {
      this.$refs['batchForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/userRecharge/batchRecharge',
            method: 'post',
            data: this.batchForm,
          })
            .then((response) => {
              this.btnLoading = false
              this.$notify({
                title: '成功',
                message: '操作成功',
                type: 'success',
                duration: 2000,
              })
              this.getList()
              this.batchModalVisible = false
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
    forbid(row) {
      let str
      if (row.is_normal == 1) {
        str = '此操作将冻结该用户, 是否继续?'
      } else {
        str = '此操作将解冻该用户, 是否继续?'
      }
      this.$confirm(str, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/users/forbid',
            method: 'post',
            data: {
              id: row.id,
              operate: row.is_normal == 1 ? 0 : 1,
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/users',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    edit(row) {
      this.$router.push('/USER/edituserinfo?id=' + row.id)
    },
    createuser() {
      this.$router.push('/USER/createuser')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
